<template>
  <v-form>
    <v-text-field
      v-model="value.label"
      :label="$t('label')"
      outlined
    />
    <v-text-field
      v-model="value.description"
      :label="$t('description')"
      outlined
    />
    <v-btn
      v-if="!loading"
      class="mt-4"
      outlined
      rounded
      @click="updateChannel"
      :disabled="!formValid()"
    >
      {{ $t('save') }}
    </v-btn>
    <v-btn
      v-else
      class="mt-4"
      outlined
      rounded
      loading
    />
  </v-form>
</template>

<script>
	export default {
		name: 'ChannelForm',
		props: {
			value: {
				type: Object,
				default: null
			}
		},
		data() {
			return {
				loading: false
			}
		},
		methods: {
			formValid() {
				return this.value && this.value.label
			},
			updateChannel() {
				if(this.formValid()) {
					this.loading = true
					this.$store.dispatch('updateChannel', this.value).then(res => {
						if(res) {
							this.$store.commit('updateActionSuccess', {
								message: this.$t('success'),
								subMessage: this.$t('channelUpdated'),
							})
						} else {
							this.$store.commit('updateActionError', {
								message: this.$t('error'),
								subMessage: this.$t('failedToUpdateChannel'),
							})
						}
					}).catch(() => {
						this.$store.commit('updateActionError', {
							message: this.$t('error'),
							subMessage: this.$t('failedToUpdateChannel'),
						})
					}).finally(() => {
						this.loading = false
					})
				}
			}
		}
	}
</script>
